import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { MdCheckCircle, MdSchedule, MdErrorOutline } from 'react-icons/md';

/**
 * Stranica na koju vodi potvrda e-maila iz registracijske poruke.
 *
 * Postoji jer klik iz maila završava u pregledniku: bez nje je korisnik gledao
 * sirovi JSON i mislio da je nešto puklo, čak i kad je prošlo.
 */
const VerifyEmailResult = () => {
    const { t } = useTranslation();
    const [params] = useSearchParams();
    const status = params.get('status') || 'invalid';
    const source = params.get('source');
    const session = params.get('session');

    const variants = {
        approved: { icon: <MdCheckCircle size={48} />, tone: '#1e7e34' },
        verified: { icon: <MdCheckCircle size={48} />, tone: '#1e7e34' },
        awaiting_review: { icon: <MdSchedule size={48} />, tone: '#b8860b' },
        invalid: { icon: <MdErrorOutline size={48} />, tone: '#b02a37' },
    };

    const variant = variants[status] || variants.invalid;

    return (
        <Wrapper>
            <Icon $tone={variant.tone}>{variant.icon}</Icon>
            <Title>{t(`VerifyEmail.${status}_title`)}</Title>
            <Message>{t(`VerifyEmail.${status}_message`)}</Message>

            {(status === 'approved' || status === 'verified') && (
                <ActionLink to="/login" onClick={() => {
                    const safeSession = /^[0-9a-f-]{36}$/i.test(session || '');
                    const safeSource = ['woocommerce', 'shopware'].includes(source) ? source : null;
                    const returnPath = safeSession && safeSource ? `/connect/${safeSource}?session=${session}` : localStorage.getItem('lastVisitedPath') || '';
                    localStorage.setItem('lastVisitedPath', returnPath.startsWith('/connect/') ? returnPath : '/setup');
                }}>
                    {source === 'woocommerce' ? t('VerifyEmail.toLoginAndConnect', 'Sign in and continue connecting WooCommerce') : t('VerifyEmail.toLogin')}
                </ActionLink>
            )}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    max-width: 420px;
    margin: 0 auto;
    padding: 2.5rem 1.5rem;
    text-align: center;
`;

const Icon = styled.div`
    color: ${({ $tone }) => $tone};
    margin-bottom: 1rem;
`;

const Title = styled.h1`
    font-size: 1.4rem;
    margin: 0 0 0.75rem;
`;

const Message = styled.p`
    font-size: 0.95rem;
    line-height: 1.6;
    opacity: 0.8;
    margin: 0 0 1.5rem;
`;

const ActionLink = styled(Link)`
    display: inline-block;
    background: #8e24aa;
    color: #fff;
    text-decoration: none;
    padding: 0.7rem 1.4rem;
    border-radius: 8px;
    font-size: 0.9rem;
`;

export default VerifyEmailResult;
